<template>
  <v-card
    data-component-id="ReopenOffer"
  >
    <v-card-title>
      Rouvrir l'offre
    </v-card-title>
    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="primary"
    />
    <v-card-text>
      <v-form
        v-model="isValidForm"
      >
        <template
          v-for="(field, fieldIndex) in fields"
        >
          <div
            :key="fieldIndex"
          >
            <component
              :is="field.component ? field.component : 'GenericField'"
              v-model="data[field.name]"
              :data="item"
              :input="field"
              :field="{
                ...field,
                disabled: isLoading
              }"
            />
          </div>
        </template>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        text
        @click="handleDisagree"
      >
        Annuler
      </v-btn>
      <v-btn
        :disabled="!isValidForm || isLoading"
        color="primary"
        text
        @click="handleAccept"
      >
        Accepter
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { requests } from '@/mixins/requests';

import GenericField from '@/components/dynamic/form/templates/GenericField.vue';
import DatePicker from '@/components/dynamic/form/components/DatePicker.vue';

export default {
  name: 'ReopenOffer',
  components: { GenericField, DatePicker },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isLoading: false,
      isValidForm: false,
      data: {},
      fields: [
        {
          name: 'endPublicationDate',
          label: 'Date de fin de publication',
          component: 'DatePicker',
          icon: 'calendar',
          type: 'date',
          min: 'startPublicationDate',
          required: true,
          mandatory: true
        }
      ]
    };
  },
  watch: {
    item: {
      handler () {
        this.initializeData();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getNestedValue (obj, path) {
      return path
        .split('.')
        .reduce((acc, part) => (acc && acc[part]), obj);
    },
    initializeData () {
      const item = JSON.parse(JSON.stringify(this.item));

      this.fields.forEach(field => {
        this.$set(
          this.data,
          field.name,
          field.computed ? this.getNestedValue(item, field.computed) : item[field.name]
        );
      });
    },
    handleDisagree () {
      this.resetDialog();
    },
    async handleAccept () {
      this.handleLoading(true);

      try {
        const response = await requests.saveOffer({
          input: {
            uuid: this.$route.params.offerUuid,
            status: 'published',
            ...this.data
          },
          isEditMode: true
        });

        if (!response.success) {
          this.$store.commit('setSnackbar', {
            text: 'Erreur lors de la publication de l\'offre.',
            color: 'error'
          });

          return;
        }

        this.$store.commit('setOffer', response.data);

        const offerLink = this.$router.resolve({ name: 'offer', params: { contentTypeLabel: 'offres', mode: 'editer', uuid: this.item.uuid } });
        const htmlMessage = `L'offre a bien été publiée. <a href="${offerLink.href}">Voir l'offre</a>`;

        this.$store.commit('setSnackbar', {
          text: htmlMessage,
          color: 'success'
        });
      } finally {
        this.$emit('close-dialog');
        this.handleLoading(false);
        this.resetDialog();
      }
    },
    handleLoading (value) {
      this.$emit('handle-loading', value);
      this.isLoading = value;
    },
    resetDialog () {
      this.data = {};
      this.$emit('close-dialog');
    }
  }
};
</script>
